<template>
  <div
    class="Contributor"
    v-bind:class="{ 'Contributor__name-list': contributor.persons.length > 1 }"
  >
    <span class="Contributor__role"> {{ contributor.text }}</span>
    <ul class="Contributor__names">
      <li class="Contributor__name" v-for="person in contributor.persons">
        <div
          :class="[
            'Contributor__name-container',
            person.comment ? 'commentClass' : 'noComment',
          ]"
        >
          <a
            v-if="person.url_cv.trim() !== ''"
            :href="person.url_cv"
            class="iframeModal"
          >
            {{ person.name }}
          </a>
          <span v-else>{{ person.name }}</span>
        </div>
        <p v-if="person.comment != ''" class="Contributor__comment">
          <span v-html="person.comment"></span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Contributor",
  props: {
    contributor: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.Contributor {
  display: flex;
  margin-bottom: 30px;
  gap: 5%;
}

.Contributor__role {
  width: 25%;
  word-wrap: break-word;
  hyphens: auto;
  color: black;
  @include breakpoint($tablet-small) {
    width: 20%;
  }
}

.Contributor__name-container {
  margin-bottom: 7px;
  margin-top: -3px;
  a {
    word-wrap: break-word;
    hyphens: auto;
  }
  @include breakpoint($phone-small) {
    width: 40%;
  }
}

.Contributor__name-container.noComment {
  width: 100%;
}

.Contributor__names {
  color: black;
  font-weight: 700;
  width: 70%;
  padding-left: 0px;
}

.Contributor__name {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-size: 15px;
  gap: 5%;
  a {
    border-bottom: 2px solid;
    color: black;
    text-decoration: none;
  }
  @include breakpoint($tablet-small) {
    flex-direction: row;
  }
}

.Contributor__comment {
  font-size: 14px;
  width: 55%;
  margin-top: -10px;
  @include breakpoint($tablet-small) {
    margin-top: -2px;
  }
}
</style>
